(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './rsocket-kotlin-rsocket-core-js-ir.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-coroutines-core.js', './fixers-f2-f2-dsl-f2-dsl-function.js', './fixers-f2-f2-client-f2-client-core.js', './kotlinx-serialization-kotlinx-serialization-json.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./rsocket-kotlin-rsocket-core-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-coroutines-core.js'), require('./fixers-f2-f2-dsl-f2-dsl-function.js'), require('./fixers-f2-f2-client-f2-client-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    if (typeof this['rsocket-kotlin-rsocket-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'rsocket-kotlin-rsocket-core-js-ir' was not found. Please, check whether 'rsocket-kotlin-rsocket-core-js-ir' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-function'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-function' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-function' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    if (typeof this['fixers-f2-f2-client-f2-client-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'fixers-f2-f2-client-f2-client-core' was not found. Please, check whether 'fixers-f2-f2-client-f2-client-core' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'.");
    }
    root['fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'] = factory(typeof this['fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'] === 'undefined' ? {} : this['fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket'], this['kotlin-kotlin-stdlib'], this['rsocket-kotlin-rsocket-core-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlinx-coroutines-core'], this['fixers-f2-f2-dsl-f2-dsl-function'], this['fixers-f2-f2-client-f2-client-core'], this['kotlinx-serialization-kotlinx-serialization-json']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_rsocket_kotlin_rsocket_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_komune_f2_f2_dsl_function, kotlin_io_komune_f2_f2_client_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var CoroutineImpl = kotlin_kotlin.$_$.n8;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var protoOf = kotlin_kotlin.$_$.fa;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var Payload = kotlin_io_rsocket_kotlin_rsocket_core.$_$.d;
  var isInterface = kotlin_kotlin.$_$.t9;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z7;
  var classMeta = kotlin_kotlin.$_$.z8;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var PayloadFromBuilder = kotlin_io_rsocket_kotlin_rsocket_core.$_$.c;
  var RoutingMetadata = kotlin_io_rsocket_kotlin_rsocket_core.$_$.a;
  var metadata = kotlin_io_rsocket_kotlin_rsocket_core.$_$.b;
  var data = kotlin_io_rsocket_kotlin_rsocket_core.$_$.e;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var getKClass = kotlin_kotlin.$_$.f;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.k4;
  var arrayOf = kotlin_kotlin.$_$.yd;
  var createKType = kotlin_kotlin.$_$.c;
  var createKTypeParameter = kotlin_kotlin.$_$.b;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.a;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var toList = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
  var copyToArray = kotlin_kotlin.$_$.z5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var arrayIterator = kotlin_kotlin.$_$.r8;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var F2Supplier = kotlin_io_komune_f2_f2_dsl_function.$_$.c;
  var F2Function = kotlin_io_komune_f2_f2_dsl_function.$_$.b;
  var F2Consumer = kotlin_io_komune_f2_f2_dsl_function.$_$.a;
  var F2ClientType_RSOCKET_getInstance = kotlin_io_komune_f2_f2_client_core.$_$.b;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var defineProp = kotlin_kotlin.$_$.b9;
  //endregion
  //region block: pre-declaration
  setMetadataFor(RSocketClient$requestStream$o$collect$slambda, 'RSocketClient$requestStream$o$collect$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($collectCOROUTINE$2, '$collectCOROUTINE$2', classMeta, CoroutineImpl);
  setMetadataFor(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($requestResponseCOROUTINE$0, '$requestResponseCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor(Response, 'Response', classMeta);
  setMetadataFor(RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda, 'RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($collectCOROUTINE$3, '$collectCOROUTINE$3', classMeta, CoroutineImpl);
  setMetadataFor(_no_name_provided__qut3iv_0, VOID, classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(RSocketF2Client$supplier$o$invoke$slambda, 'RSocketF2Client$supplier$o$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(RSocketF2Client$function$o$invoke$slambda, 'RSocketF2Client$function$o$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(RSocketF2Client$consumer$o$invoke$slambda, 'RSocketF2Client$consumer$o$invoke$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(RSocketF2Client$supplier$1, VOID, classMeta, VOID, [F2Supplier]);
  setMetadataFor(RSocketF2Client$function$1, VOID, classMeta, VOID, [F2Function]);
  setMetadataFor(RSocketF2Client$consumer$1, VOID, classMeta, VOID, [F2Consumer]);
  setMetadataFor(RSocketF2Client, 'RSocketF2Client', classMeta);
  //endregion
  function RSocketClient$requestStream$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.f5g_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RSocketClient$requestStream$o$collect$slambda).j5g = function (value, $completion) {
    var tmp = this.k5g(value, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(RSocketClient$requestStream$o$collect$slambda).xb = function (p1, $completion) {
    return this.j5g((!(p1 == null) ? isInterface(p1, Payload) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RSocketClient$requestStream$o$collect$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            tmp_0.h5g_1 = this.f5g_1;
            var tmp_1 = this;
            tmp_1.i5g_1 = this.g5g_1;
            this.la_1 = 1;
            var it = this.i5g_1;
            suspendResult = this.h5g_1.i1u(it.r5f().p3h(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(RSocketClient$requestStream$o$collect$slambda).k5g = function (value, completion) {
    var i = new RSocketClient$requestStream$o$collect$slambda(this.f5g_1, completion);
    i.g5g_1 = value;
    return i;
  };
  function RSocketClient$requestStream$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new RSocketClient$requestStream$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.j5g(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$2(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t5g_1 = _this__u8e3s4;
    this.u5g_1 = collector;
  }
  protoOf($collectCOROUTINE$2).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            tmp_0.v5g_1 = this.u5g_1;
            this.la_1 = 1;
            var tmp_1 = RSocketClient$requestStream$o$collect$slambda_0(this.v5g_1, null);
            suspendResult = this.t5g_1.w5g_1.j1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.x5g_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).i1u = function (value, $completion) {
    return this.x5g_1(value, $completion);
  };
  function _no_name_provided__qut3iv($this) {
    this.w5g_1 = $this;
  }
  protoOf(_no_name_provided__qut3iv).y5g = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$2(this, collector, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(_no_name_provided__qut3iv).j1u = function (collector, $completion) {
    return this.y5g(collector, $completion);
  };
  function $requestResponseCOROUTINE$0(_this__u8e3s4, route, jsonBody, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h5h_1 = _this__u8e3s4;
    this.i5h_1 = route;
    this.j5h_1 = jsonBody;
  }
  protoOf($requestResponseCOROUTINE$0).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            var tmp$ret$0;
            l$ret$1: do {
              var builder = new PayloadFromBuilder();
              try {
                metadata(builder, RoutingMetadata([this.i5h_1]));
                if (!(this.j5h_1 == null)) {
                  data(builder, this.j5h_1);
                }
                tmp$ret$0 = builder.lr();
                break l$ret$1;
              } catch ($p) {
                if ($p instanceof Error) {
                  var t = $p;
                  builder.u3g();
                  throw t;
                } else {
                  throw $p;
                }
              }
            }
             while (false);
            tmp_0.k5h_1 = tmp$ret$0;
            this.la_1 = 1;
            suspendResult = this.h5h_1.l5h_1.m5f(this.k5h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            return response.r5f().p3h();
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  function Response(paylaod) {
    this.m5h_1 = paylaod;
  }
  protoOf(Response).toString = function () {
    return 'Response(paylaod=' + this.m5h_1 + ')';
  };
  protoOf(Response).hashCode = function () {
    return this.m5h_1 == null ? 0 : hashCode(this.m5h_1);
  };
  protoOf(Response).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Response))
      return false;
    var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
    if (!equals(this.m5h_1, tmp0_other_with_cast.m5h_1))
      return false;
    return true;
  };
  function RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation) {
    this.v5h_1 = $$this$unsafeFlow;
    this.w5h_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda).a5i = function (value, $completion) {
    var tmp = this.b5i(value, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda).xb = function (p1, $completion) {
    return this.a5i((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            tmp_0.y5h_1 = this.v5h_1;
            var tmp_1 = this;
            tmp_1.z5h_1 = this.x5h_1;
            this.la_1 = 1;
            var it = this.z5h_1;
            var this_0 = this.w5h_1.e5i_1;
            var this_1 = this_0.jm();
            var this_2 = serializer(this_1, createKType(getKClass(Response), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('RESPONSE', arrayOf([createKType(PrimitiveClasses_getInstance().u6(), arrayOf([]), true)]), 'invariant'), arrayOf([]), false))]), false));
            suspendResult = this.y5h_1.i1u(this_0.mj(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), it).m5h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda).b5i = function (value, completion) {
    var i = new RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda(this.v5h_1, this.w5h_1, completion);
    i.x5h_1 = value;
    return i;
  };
  function RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda_0($$this$unsafeFlow, this$0, resultContinuation) {
    var i = new RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation);
    var l = function (value, $completion) {
      return i.a5i(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$3(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n5i_1 = _this__u8e3s4;
    this.o5i_1 = collector;
  }
  protoOf($collectCOROUTINE$3).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            tmp_0.p5i_1 = this.o5i_1;
            this.la_1 = 1;
            var tmp_1 = RSocketF2Client$supplier$o$invoke$slambda$o$collect$slambda_0(this.p5i_1, this.n5i_1.r5i_1, null);
            suspendResult = this.n5i_1.q5i_1.j1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf($collectCOROUTINE$3)['<set-state>'] = protoOf($collectCOROUTINE$3).va;
  protoOf($collectCOROUTINE$3)['<get-state>'] = protoOf($collectCOROUTINE$3).wa;
  protoOf($collectCOROUTINE$3)['<set-exceptionState>'] = protoOf($collectCOROUTINE$3).xa;
  protoOf($collectCOROUTINE$3)['<get-exceptionState>'] = protoOf($collectCOROUTINE$3).ya;
  protoOf($collectCOROUTINE$3)['<set-result>'] = protoOf($collectCOROUTINE$3).za;
  protoOf($collectCOROUTINE$3)['<get-result>'] = protoOf($collectCOROUTINE$3).ab;
  protoOf($collectCOROUTINE$3)['<set-exception>'] = protoOf($collectCOROUTINE$3).bb;
  protoOf($collectCOROUTINE$3)['<get-exception>'] = protoOf($collectCOROUTINE$3).cb;
  protoOf($collectCOROUTINE$3)['<set-finallyPath>'] = protoOf($collectCOROUTINE$3).db;
  protoOf($collectCOROUTINE$3)['<get-finallyPath>'] = protoOf($collectCOROUTINE$3).eb;
  protoOf($collectCOROUTINE$3)['<get-context>'] = protoOf($collectCOROUTINE$3).sa;
  function _no_name_provided__qut3iv_0($this, this$0) {
    this.q5i_1 = $this;
    this.r5i_1 = this$0;
  }
  protoOf(_no_name_provided__qut3iv_0).s5i = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$3(this, collector, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(_no_name_provided__qut3iv_0).j1u = function (collector, $completion) {
    return this.s5i(collector, $completion);
  };
  function RSocketF2Client$supplier$o$invoke$slambda(this$0, $route, resultContinuation) {
    this.b5j_1 = this$0;
    this.c5j_1 = $route;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RSocketF2Client$supplier$o$invoke$slambda).k5e = function ($this$promise, $completion) {
    var tmp = this.i3e($this$promise, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(RSocketF2Client$supplier$o$invoke$slambda).xb = function (p1, $completion) {
    return this.k5e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RSocketF2Client$supplier$o$invoke$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            this.la_1 = 1;
            var this_0 = this.b5j_1.c5i_1.e5j(this.c5j_1);
            suspendResult = toList(new _no_name_provided__qut3iv_0(this_0, this.b5j_1), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_1 = suspendResult;
            return copyToArray(this_1);
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(RSocketF2Client$supplier$o$invoke$slambda).i3e = function ($this$promise, completion) {
    var i = new RSocketF2Client$supplier$o$invoke$slambda(this.b5j_1, this.c5j_1, completion);
    i.d5j_1 = $this$promise;
    return i;
  };
  function RSocketF2Client$supplier$o$invoke$slambda_0(this$0, $route, resultContinuation) {
    var i = new RSocketF2Client$supplier$o$invoke$slambda(this$0, $route, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.k5e($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function RSocketF2Client$function$o$invoke$slambda($cmd, this$0, $queryTypeInfo, $route, resultContinuation) {
    this.n5j_1 = $cmd;
    this.o5j_1 = this$0;
    this.p5j_1 = $queryTypeInfo;
    this.q5j_1 = $route;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RSocketF2Client$function$o$invoke$slambda).k5e = function ($this$promise, $completion) {
    var tmp = this.i3e($this$promise, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(RSocketF2Client$function$o$invoke$slambda).xb = function (p1, $completion) {
    return this.k5e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RSocketF2Client$function$o$invoke$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 4;
            var tmp_0 = this;
            tmp_0.s5j_1 = this.n5j_1;
            var tmp_1 = this;
            tmp_1.t5j_1 = this.s5j_1;
            var tmp_2 = this;
            tmp_2.u5j_1 = ArrayList_init_$Create$(this.s5j_1.length);
            this.v5j_1 = arrayIterator(this.t5j_1);
            this.la_1 = 1;
            continue $sm;
          case 1:
            if (!this.v5j_1.v()) {
              this.la_1 = 3;
              continue $sm;
            }

            this.w5j_1 = this.v5j_1.w();
            var tmp_3 = this;
            tmp_3.x5j_1 = this.w5j_1;
            this.y5j_1 = handlePayload(this.o5j_1, this.n5j_1, this.p5j_1);
            this.la_1 = 2;
            suspendResult = this.o5j_1.c5i_1.z5j(this.q5j_1, this.y5j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var payload = suspendResult;
            var this_0 = this.o5j_1.e5i_1;
            var this_1 = this_0.jm();
            var this_2 = serializer(this_1, createKType(getKClass(Response), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('RESPONSE', arrayOf([createKType(PrimitiveClasses_getInstance().u6(), arrayOf([]), true)]), 'invariant'), arrayOf([]), false))]), false));
            var ARGUMENT = this_0.mj(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), payload).m5h_1;
            this.u5j_1.r(ARGUMENT);
            this.la_1 = 1;
            continue $sm;
          case 3:
            var this_3 = this.u5j_1;
            return copyToArray(this_3);
          case 4:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 4) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(RSocketF2Client$function$o$invoke$slambda).i3e = function ($this$promise, completion) {
    var i = new RSocketF2Client$function$o$invoke$slambda(this.n5j_1, this.o5j_1, this.p5j_1, this.q5j_1, completion);
    i.r5j_1 = $this$promise;
    return i;
  };
  function RSocketF2Client$function$o$invoke$slambda_0($cmd, this$0, $queryTypeInfo, $route, resultContinuation) {
    var i = new RSocketF2Client$function$o$invoke$slambda($cmd, this$0, $queryTypeInfo, $route, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.k5e($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function RSocketF2Client$consumer$o$invoke$slambda(this$0, $cmd, $queryTypeInfo, $route, resultContinuation) {
    this.i5k_1 = this$0;
    this.j5k_1 = $cmd;
    this.k5k_1 = $queryTypeInfo;
    this.l5k_1 = $route;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RSocketF2Client$consumer$o$invoke$slambda).h3e = function ($this$promise, $completion) {
    var tmp = this.i3e($this$promise, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(RSocketF2Client$consumer$o$invoke$slambda).xb = function (p1, $completion) {
    return this.h3e((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RSocketF2Client$consumer$o$invoke$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            this.n5k_1 = handlePayload(this.i5k_1, this.j5k_1, this.k5k_1);
            this.la_1 = 1;
            suspendResult = this.i5k_1.c5i_1.o5k(this.l5k_1, this.n5k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(RSocketF2Client$consumer$o$invoke$slambda).i3e = function ($this$promise, completion) {
    var i = new RSocketF2Client$consumer$o$invoke$slambda(this.i5k_1, this.j5k_1, this.k5k_1, this.l5k_1, completion);
    i.m5k_1 = $this$promise;
    return i;
  };
  function RSocketF2Client$consumer$o$invoke$slambda_0(this$0, $cmd, $queryTypeInfo, $route, resultContinuation) {
    var i = new RSocketF2Client$consumer$o$invoke$slambda(this$0, $cmd, $queryTypeInfo, $route, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.h3e($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function handlePayload($this, obj, typeInfo) {
    var serializer = serializer_0(ensureNotNull(typeInfo.d3r_1));
    return $this.e5i_1.lj(serializer, obj);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.p5k_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).i1u = function (value, $completion) {
    return this.p5k_1(value, $completion);
  };
  function RSocketF2Client$supplier$1(this$0, $route) {
    this.q5k_1 = this$0;
    this.r5k_1 = $route;
  }
  protoOf(RSocketF2Client$supplier$1).invoke = function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, RSocketF2Client$supplier$o$invoke$slambda_0(this.q5k_1, this.r5k_1, null));
  };
  function RSocketF2Client$function$1(this$0, $queryTypeInfo, $route) {
    this.s5k_1 = this$0;
    this.t5k_1 = $queryTypeInfo;
    this.u5k_1 = $route;
  }
  protoOf(RSocketF2Client$function$1).invoke = function (cmd) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, RSocketF2Client$function$o$invoke$slambda_0(cmd, this.s5k_1, this.t5k_1, this.u5k_1, null));
  };
  function RSocketF2Client$consumer$1(this$0, $queryTypeInfo, $route) {
    this.v5k_1 = this$0;
    this.w5k_1 = $queryTypeInfo;
    this.x5k_1 = $route;
  }
  protoOf(RSocketF2Client$consumer$1).invoke = function (cmd) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, RSocketF2Client$consumer$o$invoke$slambda_0(this.v5k_1, cmd, this.w5k_1, this.x5k_1, null));
  };
  function RSocketF2Client$json$lambda($this$Json) {
    $this$Json.k13_1 = true;
    return Unit_instance;
  }
  function RSocketF2Client(rSocketClient) {
    this.c5i_1 = rSocketClient;
    this.d5i_1 = F2ClientType_RSOCKET_getInstance();
    var tmp = this;
    tmp.e5i_1 = Json(VOID, RSocketF2Client$json$lambda);
  }
  protoOf(RSocketF2Client).j21 = function () {
    return this.d5i_1;
  };
  protoOf(RSocketF2Client).supplier = function (route, typeInfo) {
    return new RSocketF2Client$supplier$1(this, route);
  };
  protoOf(RSocketF2Client).function = function (route, queryTypeInfo, responseTypeInfo) {
    return new RSocketF2Client$function$1(this, queryTypeInfo, route);
  };
  protoOf(RSocketF2Client).consumer = function (route, queryTypeInfo) {
    return new RSocketF2Client$consumer$1(this, queryTypeInfo, route);
  };
  //region block: post-declaration
  defineProp(protoOf(RSocketF2Client), 'type', function () {
    return this.j21();
  });
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$client = $f2.client || ($f2.client = {});
    var $f2$client$ktor = $f2$client.ktor || ($f2$client.ktor = {});
    var $f2$client$ktor$rsocket = $f2$client$ktor.rsocket || ($f2$client$ktor.rsocket = {});
    $f2$client$ktor$rsocket.RSocketF2Client = RSocketF2Client;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-f2-f2-client-f2-client-ktor-f2-client-ktor-rsocket.js.map
